'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const HarvestChartInner = dynamic(
  () => import('./HarvestChartInner'),
  { ssr: false, loading: () => <div className="animate-pulse bg-muted rounded-xl h-52" /> }
);

export default function HarvestChart() {
  return <HarvestChartInner />;
}